import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { omit } from 'lodash';

import DeleteFundSearchAlert from 'buyside/graphql/mutations/DeleteFundSearchAlert';
import UpdateUserFundSearchAlert from 'buyside/graphql/mutations/UpdateUserFundSearchAlert';

import SavedSearchAlertItem from 'buyside/components/presentation/UserAccount/SavedSearches/savedSearchAlertItem';

const SavedSearchAlertFundContainer = ({ alert, addToParentsSoftDelete, ...props }) => {
  const { id, active, display, name } = alert;

  const initialValues = { fundSearchAlertId: id, active, display };
  const alertNameValues = { fundSearchAlertId: id, name };

  const criteriaObj = omit(
    JSON.parse(alert.employerProfileSavedSearch.criteria),
    'ticker',
    'city_id'
  );

  return (
    <Mutation mutation={UpdateUserFundSearchAlert}>
      {mutate => {
        const updateFundSearchAlert = args => mutate({ variables: args });
        return (
          <Mutation mutation={DeleteFundSearchAlert}>
            {mutate => {
              const deleteFundSearchAlert = fundSearchAlertId =>
                mutate({
                  variables: { fundSearchAlertId }
                });
              return (
                <SavedSearchAlertItem
                  updateSearchAlert={updateFundSearchAlert}
                  handleDeleteSearchAlert={alert => {
                    deleteFundSearchAlert(alert.id);
                    addToParentsSoftDelete(alert);
                  }}
                  initialValues={initialValues}
                  criteriaObj={criteriaObj}
                  alertNameValues={alertNameValues}
                  alert={alert}
                  label="Email me about new fund profiles matching this search"
                  {...props}
                />
              );
            }}
          </Mutation>
        );
      }}
    </Mutation>
  );
};
export default SavedSearchAlertFundContainer;
